import { useSession } from '@/modules/auth/hooks/useSession'
import { type FindexInvestment, type FullInvestment } from 'findef'
import { computed, defineComponent, type MaybeRef } from 'vue'
import { Spinner } from 'components/spinner'
import { TreeV2 } from 'components/treev2'
import type { ITreeV2Props } from 'components/treev2/types'
import type { UseForexTickers } from '@/integrations/findex/hooks/forex/useForexTickers'
import { useInvestmentTree } from '../../hooks/useInvestmentTree'

export const InvestmentTree = defineComponent<{
  investment?: MaybeRef<FindexInvestment | FullInvestment>
  forex?: UseForexTickers;
  treeProps?: Partial<ITreeV2Props>;
  mockInvestment?: MaybeRef<FindexInvestment | FullInvestment>;
  realParentId?: MaybeRef<string>;
}>((props) => {
  const forex = props.forex
  const session = useSession()

  const hook = useInvestmentTree({
    forex,
    session,
    investment: props.investment,
    mockInvestment: props.mockInvestment,
    realParentId: props.realParentId
  });

  const isLoading = computed(() => hook.isLoading.value)

  return () => {
    if (isLoading.value) {
      return (
        <div class="w-full h-full flex items-center justify-center content-center">
          <Spinner />
        </div>
      )
    }
    return (
      <div>
        <TreeV2 {...(props.treeProps || {})} node={hook.tree.value} />
      </div>
    )
  }
}, { props: ['investment', 'forex', 'treeProps', 'mockInvestment', 'realParentId'] })
